import React, { createContext, useContext, useState, useCallback } from 'react';

const HeaderContext = createContext();

export const HeaderProvider = ({ children }) => {
	const [headerProps, setHeaderProps] = useState({
		title: '',
		buttons: []
	});

	const updateHeaderProps = useCallback((props) => {
		setHeaderProps(props);
	}, []);

	return (
		<HeaderContext.Provider value={{ headerProps, updateHeaderProps }}>
			{children}
		</HeaderContext.Provider>
	);
};

export const useHeader = () => {
	const context = useContext(HeaderContext);
	if (!context) {
		throw new Error('useHeader must be used within a HeaderProvider');
	}
	return context;
};
